import React from "react";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  label?: string;
}
const ToggleSwitch = (props: ToggleSwitchProps) => {
  const { checked, onChange, label } = props;
  return (
    <div className="flex items-center">
      <span className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">
        {label}
      </span>
      <button
        type="button"
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 cursor-pointer ${
          checked ? "bg-teal-500" : "bg-gray-200 dark:bg-gray-700"
        }`}
        onClick={onChange}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            checked ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
};
export default React.memo(ToggleSwitch);
